import { useEffect, type ReactNode } from 'react';

export const APP_NAME = '外国漁船操業等調査・監視事業システム';

export interface PageHeaderProps {
  title: string;
  /** タイトル上の小見出し（機能グループ名など） */
  eyebrow?: ReactNode;
  description?: ReactNode;
  /** 右側の操作ボタン群（新規登録・帳票出力など） */
  actions?: ReactNode;
  /** タイトル横のバッジ等 */
  meta?: ReactNode;
}

/** ページタイトル＋操作ボタン。document.title も更新する */
export function PageHeader({ title, eyebrow, description, actions, meta }: PageHeaderProps) {
  useEffect(() => {
    document.title = `${title}｜${APP_NAME}`;
  }, [title]);
  return (
    <header className="bs-page-header">
      <div className="bs-page-header__main">
        {eyebrow && <div className="bs-page-header__eyebrow">{eyebrow}</div>}
        <div className="bs-page-header__title-row">
          <h1 className="bs-page-header__title">{title}</h1>
          {meta && <div className="bs-page-header__meta">{meta}</div>}
        </div>
        {description && <p className="bs-page-header__desc">{description}</p>}
      </div>
      {actions && <div className="bs-page-header__actions">{actions}</div>}
    </header>
  );
}
